import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_4 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/CustomFormList/CustomFormNode.vue';
import __unplugin_components_3 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ImgUpload.vue';
import __unplugin_components_2 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/CustomFormList/SmyMapAddress.vue';
import __unplugin_components_1 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/Base/SinglePicker.vue';
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/Alert.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "create-order no-group-border"
  }, [_vm.hasCache ? _c(__unplugin_components_0, {
    staticClass: "titleTip-temp",
    attrs: {
      "closable": true
    },
    on: {
      "on-close": _vm.clearCache
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.getCache({
          clear: true
        });
      }
    }
  }, [_vm._v(" " + i18n.tc("402") + " ")]) : _vm._e(), _c('view-box', {
    ref: "viewBox"
  }, [_c('group', {
    staticClass: "mt0"
  }, [_c('x-input', {
    attrs: {
      "readonly": "",
      "title": "",
      "placeholder": i18n.tc("239")
    },
    model: {
      value: _vm.template.service_name,
      callback: function ($$v) {
        _vm.$set(_vm.template, "service_name", $$v);
      },
      expression: "template.service_name"
    }
  }, [_c('div', {
    style: {
      position: 'relative',
      width: 120 + 'px'
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(i18n.tc("69"))])])], 1), _vm.customerList.length && _vm.isShowCustomerInput ? _c('group', {
    staticClass: "mt0"
  }, [_c(__unplugin_components_1, {
    staticClass: "customerList",
    attrs: {
      "title": i18n.tc("155"),
      "data": _vm.customerList,
      "format": function (v) {
        return {
          name: v.name,
          value: String(v.fk_t_customer_id)
        };
      }
    },
    model: {
      value: _vm.systemFields.fk_t_customer_id,
      callback: function ($$v) {
        _vm.$set(_vm.systemFields, "fk_t_customer_id", $$v);
      },
      expression: "systemFields.fk_t_customer_id"
    }
  }, [_c('div', {
    style: {
      position: 'relative',
      width: 120 + 'px'
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(i18n.tc("155"))])])], 1) : _vm._e(), _vm._l(_vm.fieldListBeta, function (item, index) {
    return _c('div', {
      key: index
    }, [_vm.getFieldKey(item) === 'orderCustomer' ? _c('div', [_c('group', {
      staticClass: "mt0"
    }, [_c('x-input', {
      attrs: {
        "title": i18n.tc("241"),
        "placeholder": i18n.tc("239")
      },
      model: {
        value: _vm.systemFields.custom_name,
        callback: function ($$v) {
          _vm.$set(_vm.systemFields, "custom_name", $$v);
        },
        expression: "systemFields.custom_name"
      }
    }, [_c('div', {
      style: {
        position: 'relative',
        width: 120 + 'px'
      },
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_c('span', {
      staticClass: "form-red-star"
    }, [_vm._v("*")]), _vm._v(" " + i18n.tc("241") + " ")])]), _c('x-input', {
      attrs: {
        "type": "tel",
        "title": i18n.tc("157"),
        "placeholder": i18n.tc("239")
      },
      model: {
        value: _vm.systemFields.custom_phone,
        callback: function ($$v) {
          _vm.$set(_vm.systemFields, "custom_phone", $$v);
        },
        expression: "systemFields.custom_phone"
      }
    }, [_c('div', {
      style: {
        position: 'relative',
        width: 120 + 'px'
      },
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_c('span', {
      staticClass: "form-red-star"
    }, [_vm._v("*")]), _vm._v(" " + i18n.tc("157") + " ")])]), _vm.template.o_service_address_view === 1 ? _c(__unplugin_components_2, {
      attrs: {
        "defaultAddress": _vm.systemFields.map_name,
        "defaultLatLong": [_vm.systemFields.custom_longitude, _vm.systemFields.custom_latitude],
        "defaultCode": _vm.defaultCode,
        "type": _vm.systemFields.address_type
      },
      on: {
        "on-change": _vm.selectAddress
      }
    }, [_c('div', {
      style: {
        position: 'relative',
        width: 120 + 'px'
      },
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_c('span', {
      staticClass: "form-red-star"
    }, [_vm._v("*")]), _vm._v(" " + i18n.tc("242") + " ")]), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.changeAddressList.length > 1,
        expression: "changeAddressList.length > 1"
      }],
      staticClass: "btn btn1",
      attrs: {
        "slot": "right"
      },
      on: {
        "click": function ($event) {
          return _vm.$refs.showChangeAddress.show();
        }
      },
      slot: "right"
    }, [_c('img', {
      staticClass: "img",
      attrs: {
        "src": "/spa_static_mobile/icon/selectadress34_34@3x.png"
      }
    }), _c('span', [_vm._v(i18n.tc("243"))])])]) : _vm._e(), _c('x-input', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.c_detailaddress_view === 1,
        expression: "item.c_detailaddress_view === 1"
      }],
      attrs: {
        "title": i18n.tc("244"),
        "placeholder": i18n.tc("245"),
        "show-clear": true
      },
      model: {
        value: _vm.systemFields.custom_detail_addr,
        callback: function ($$v) {
          _vm.$set(_vm.systemFields, "custom_detail_addr", $$v);
        },
        expression: "systemFields.custom_detail_addr"
      }
    }, [_c('div', {
      style: {
        position: 'relative',
        width: 120 + 'px'
      },
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v(i18n.tc("244"))])])], 1)], 1) : _vm.getFieldKey(item) === 'orderCustomerPro' ? _c('div', [!_vm.isEdit ? _c('group', {
      staticClass: "mt0"
    }, [_c('div', {
      staticClass: "produce-box box"
    }, [_c('h6', {
      staticClass: "produce-title"
    }, [_vm._v(i18n.tc("226"))]), _vm._l(_vm.objectCustomerProductions, function (item, index) {
      return _c('div', {
        key: index,
        staticClass: "produce-info"
      }, [_c('img', {
        attrs: {
          "src": _vm.replaceMultiImg(item.img_url || '/spa_static_mobile/icon/spare120_120@3x.png'),
          "alt": ""
        }
      }), _c('div', {
        staticClass: "info"
      }, [_c('div', {
        staticClass: "name"
      }, [_vm._v(_vm._s(item.productName))]), _c('div', {
        staticClass: "name"
      }, [_vm._v(i18n.tc("403") + _vm._s(item.production_sn))]), item.customerProductionId ? _c('div', {
        staticClass: "name"
      }, [_vm._v(" " + i18n.tc("404") + " "), _c('span', {
        staticStyle: {
          "color": "#02a7f0"
        },
        on: {
          "click": function ($event) {
            return _vm.handleEditFault(index);
          }
        }
      }, [_vm._v(i18n.tc("405"))])]) : _vm._e()]), !_vm.cpId ? _c('div', {
        staticClass: "delBtn",
        on: {
          "click": function ($event) {
            return _vm.objectCustomerProductions.splice(index, 1);
          }
        }
      }, [_c('img', {
        staticStyle: {
          "width": "1.5rem",
          "height": "1.5rem"
        },
        attrs: {
          "src": require("@/assets/icon/delete.png"),
          "alt": "delete"
        }
      })]) : _vm._e()]);
    }), !_vm.cpId ? _c('x-button', {
      attrs: {
        "type": "primary"
      },
      nativeOn: {
        "click": function ($event) {
          _vm.isShowProduct = true;
        }
      }
    }, [_vm._v(i18n.tc("229"))]) : _vm._e()], 2)]) : _vm._e()], 1) : _vm.getFieldKey(item) === 'orderTittle' ? _c('div', [_c('group', {
      staticClass: "mt0"
    }, [_c('cell', [_c('div', {
      staticStyle: {
        "display": "flex",
        "width": "100%"
      },
      attrs: {
        "slot": "child"
      },
      slot: "child"
    }, [_c('div', {
      style: {
        position: 'relative',
        width: 120 + 'px'
      }
    }, [_c('span', {
      staticClass: "form-red-star"
    }, [_vm._v("*")]), _vm._v(" " + i18n.tc("406") + " ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.systemFields.title,
        expression: "systemFields.title"
      }],
      staticClass: "weui-input",
      staticStyle: {
        "flex": "1"
      },
      attrs: {
        "type": "text",
        "placeholder": i18n.tc("239")
      },
      domProps: {
        "value": _vm.systemFields.title
      },
      on: {
        "input": function ($event) {
          if ($event.target.composing) {
            return;
          }
          _vm.$set(_vm.systemFields, "title", $event.target.value);
        }
      }
    })])])], 1)], 1) : _vm.getFieldKey(item) === 'orderPriority' ? _c('div', [item.o_priority_view && _vm.isShowPriority ? _c('group', {
      staticClass: "mt0"
    }, [_c('popup-picker', {
      attrs: {
        "show-name": "",
        "title": i18n.tc("407"),
        "placeholder": i18n.tc("237"),
        "value-text-align": "right",
        "columns": 1,
        "data": _vm.priorityList
      },
      model: {
        value: _vm.priority,
        callback: function ($$v) {
          _vm.priority = $$v;
        },
        expression: "priority"
      }
    })], 1) : _vm._e()], 1) : _vm.getFieldKey(item) === 'orderAppointment' ? _c('div', [item.o_appointment_view === 1 ? _c('group', {
      staticClass: "mt0"
    }, [_c('datetime', {
      attrs: {
        "title": i18n.tc("154"),
        "format": "YYYY-MM-DD HH:mm",
        "placeholder": i18n.tc("154"),
        "start-date": new Date().Format('YYYY-MM-DD')
      },
      on: {
        "on-show": _vm.pickerFcous
      },
      model: {
        value: _vm.systemFields.custom_apply_time,
        callback: function ($$v) {
          _vm.$set(_vm.systemFields, "custom_apply_time", $$v);
        },
        expression: "systemFields.custom_apply_time"
      }
    }, [_c('div', {
      style: {
        position: 'relative',
        width: 120 + 'px'
      },
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_c('span', {
      staticClass: "form-red-star"
    }, [_vm._v("*")]), _vm._v(" " + i18n.tc("154") + " ")])])], 1) : _vm._e()], 1) : _vm.getFieldKey(item) === 'orderAppointmentComplete' ? _c('div', [_c('group', {
      staticClass: "mt0"
    }, [_c('datetime', {
      attrs: {
        "title": i18n.tc("408"),
        "format": "YYYY-MM-DD HH:mm",
        "placeholder": i18n.tc("408"),
        "start-date": new Date().Format('YYYY-MM-DD')
      },
      model: {
        value: _vm.systemFields.EstimateCompleteTime,
        callback: function ($$v) {
          _vm.$set(_vm.systemFields, "EstimateCompleteTime", $$v);
        },
        expression: "systemFields.EstimateCompleteTime"
      }
    }, [_c('div', {
      style: {
        position: 'relative',
        width: 120 + 'px'
      },
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_c('span', {
      staticClass: "form-red-star"
    }, [_vm._v("*")]), _vm._v(" " + i18n.tc("408") + " ")])])], 1)], 1) : _vm.getFieldKey(item) === 'orderDescri' ? _c('div', [item.o_descri_view === 1 ? _c('group', {
      staticClass: "mt0"
    }, [_c('x-textarea', {
      staticClass: "smy__textarea",
      attrs: {
        "show-counter": "",
        "name": "detail",
        "title": i18n.tc("160"),
        "placeholder": i18n.tc("409"),
        "max": 500
      },
      model: {
        value: _vm.systemFields.detail_desc,
        callback: function ($$v) {
          _vm.$set(_vm.systemFields, "detail_desc", $$v);
        },
        expression: "systemFields.detail_desc"
      }
    })], 1) : _vm._e()], 1) : _vm.getFieldKey(item) === 'orderImg' ? _c('div', [item.o_img_view === 1 ? _c('group', {
      staticClass: "mt0"
    }, [_c(__unplugin_components_3, {
      attrs: {
        "hidden-border": "",
        "title": i18n.tc("410")
      },
      on: {
        "on-change": function ($event) {
          _vm.systemFields.image_descri_list = $event;
        }
      },
      model: {
        value: _vm.systemFields.image_descri_list,
        callback: function ($$v) {
          _vm.$set(_vm.systemFields, "image_descri_list", $$v);
        },
        expression: "systemFields.image_descri_list"
      }
    })], 1) : _vm._e()], 1) : !item.is_system ? _c(__unplugin_components_4, {
      ref: "CustomFormNode",
      refInFor: true,
      attrs: {
        "index": index,
        "node": item.fieldMap,
        "fieldList": _vm.customFields
      },
      on: {
        "on-customField": _vm.onCustomField
      }
    }) : _vm._e()], 1);
  }), _c('div', {
    staticClass: "bottom-bar",
    attrs: {
      "slot": "bottom"
    },
    slot: "bottom"
  }, [!_vm.oid ? _c('div', {
    staticClass: "btn-body"
  }, [_c('x-button', {
    staticClass: "no-border-radius",
    nativeOn: {
      "click": function ($event) {
        return _vm.tempSave.apply(null, arguments);
      }
    }
  }, [_vm._v(i18n.tc("411"))])], 1) : _vm._e(), _c('div', {
    staticClass: "btn-body"
  }, [_c('x-button', {
    staticClass: "no-border-radius",
    attrs: {
      "type": "primary",
      "show-loading": _vm.btnLoading,
      "disabled": _vm.btnLoading
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.submit.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.btnLoading ? i18n.tc("234") : i18n.tc("247")) + " ")])], 1)])], 2), _c('SelectCustomer', {
    attrs: {
      "list": _vm.customerList
    },
    on: {
      "on-success": _vm.onSelectCustomer
    },
    model: {
      value: _vm.isShowSelectCustomer,
      callback: function ($$v) {
        _vm.isShowSelectCustomer = $$v;
      },
      expression: "isShowSelectCustomer"
    }
  }), _c('AddProduct', {
    on: {
      "on-success": _vm.getCustomerPro
    },
    model: {
      value: _vm.isShowProduct,
      callback: function ($$v) {
        _vm.isShowProduct = $$v;
      },
      expression: "isShowProduct"
    }
  }), _c('AddFault', {
    attrs: {
      "faultsOld": _vm.objectCustomerProductionsIndexObj ? _vm.objectCustomerProductionsIndexObj.fault : []
    },
    on: {
      "callback": _vm.handleBackFault
    },
    model: {
      value: _vm.isShowAddFault,
      callback: function ($$v) {
        _vm.isShowAddFault = $$v;
      },
      expression: "isShowAddFault"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };